var _excluded = ["fillColor"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
var SvgBellRing = function SvgBellRing(_ref) {
  var fillColor = _ref.fillColor,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: fillColor || "#FF5B27",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.845 14.5a1.333 1.333 0 0 0 2.31 0M14.667 5.834c0-1.534-.534-2.867-1.334-4M2.175 10.718a.667.667 0 0 0 .492 1.116h10.666a.667.667 0 0 0 .494-1.116C12.94 9.804 12 8.833 12 5.834a4 4 0 1 0-8 0c0 2.999-.94 3.97-1.825 4.884M2.667 1.834c-.8 1.133-1.334 2.466-1.334 4"
  }));
};
export default SvgBellRing;